module.exports = __webpack_public_path__ + "static/media/general-settings-icon.b86e6eb7.svg";